(function () {
    'use strict';

    angular
        .module('highSchoolVisit')
        .controller('HighSchoolVisitExhibitorTransportationController', HighSchoolVisitExhibitorTransportationController);

        HighSchoolVisitExhibitorTransportationController.$inject = ['HighSchoolVisitService','CitiesByExpoService','$timeout'];

    function HighSchoolVisitExhibitorTransportationController(HighSchoolVisitService,CitiesByExpoService,$timeout) {
        var vm = this;

        vm.flag                  = false;
        vm.expos                 = [];
        vm.selectExpo            = selectExpo;
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.getByFilter           = getByFilter;
        vm.getByFilterCsv        = getByFilterCsv;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        activate();

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            vm.query = {};
            HighSchoolVisitService.getExpos(vm.query).then(function(response){
                vm.expos = response.data;
            });
        }

        function getByFilter () {
            let query           = {};
            vm.flag             = false;
            query['page']       = vm.page;
            query['expo_id']    = vm.expoSelected;
            HighSchoolVisitService.getExpoUserTransportations(query).then(function(response) {
                console.log(response);
                vm.flag = true;
                vm.transportations = response.data.data;
                vm.totalItems = response.data.totalItems;
                vm.itemsPerPage = response.data.perPage;
                vm.setPage(response.data.currentPage);
            });
        }

        function getByFilterCsv () {
            let query           = {};
            query['page']       = vm.page;
            query['expo_id']    = vm.expoSelected;
            HighSchoolVisitService.getExpoUserTransportationsCsv(query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'high_school_tours_transportations_' + vm.expoSelected + '.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }
    }

})();